export const STATUS_ENUM = {
  NO_ACCOUNT: 0,
  NO_REGISTER: 1,
  NO_PAY: 2,
  PAID: 3
}